var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jujiagantongrumenkecheng"},[_c('PublicCert',{attrs:{"logo":_vm.Logo12,"type":'jy-hsi',"color":'#3390cf'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }